// src/firebase.ts
import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getFirestore } from "firebase/firestore";

const firebaseConfig = {
  apiKey: "AIzaSyBNWWcxOCbAwkBfYvdWd9ujeqFqhj0mn0A",
  authDomain: "penpalboard.firebaseapp.com",
  projectId: "penpalboard",
  storageBucket: "penpalboard.appspot.com",
  messagingSenderId: "816250316364",
  appId: "1:816250316364:web:cb82a78f01f48ef20eb6e9",
  measurementId: "G-1ELC39W5ZH",
};

const app = initializeApp(firebaseConfig);
export const auth = getAuth(app);
export const db = getFirestore(app);
